import { render, staticRenderFns } from "./TxRowInlineNft.vue?vue&type=template&id=a74aa3e8"
import script from "./TxRowInlineNft.vue?vue&type=script&lang=js"
export * from "./TxRowInlineNft.vue?vue&type=script&lang=js"
import style0 from "./TxRowInlineNft.vue?vue&type=style&index=0&id=a74aa3e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports